




















import mixins from 'vue-typed-mixins';
import HumanResourcesTable from '../HumanResourcesTable.vue';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    HumanResourcesTable,
  },
  props: {
    question: {
      type: Object as () => Question,
    },
  },
  computed: {
    headers(): any[] {
      return [
        ...this.$attrs.headers,
        {
          text: this.$translate(this.question.options.language.totalfte),
          value: 'positioncount.totalfte',
        },
        {
          text: this.$translate(this.question.options.language.dbpfilledwith),
          value: 'positioncount.dbpfilledwith',
        },
        {
          text: this.$translate(
            this.question.options.language.dbpfilledwithout
          ),
          value: 'positioncount.dbpfilledwithout',
        },
        {
          text: this.$translate(this.question.options.language.vacant),
          value: 'positioncount.vacant',
        },
        {
          text: this.$translate(this.question.options.language.nondbp),
          value: 'positioncount.nondbp',
        },
      ];
    },
  },
  methods: {
    displayvacant(positioncount: any) {
      return (
        parseFloat(positioncount.totalfte) -
        parseFloat(positioncount.dbpfilledwith) -
        parseFloat(positioncount.dbpfilledwithout)
      );
    },
    displayNumber(value: any) {
      return parseFloat(value || 0)?.toFixed(2);
    },
  },
});
